export default __webpack_public_path__ + "static/Deemoney_logo-bb6bcc5b2fc5ae0142e41579444531c0.png";